module.exports = __webpack_public_path__ + "static/img/1.54a391f9.png";